import { analytics_methods } from "./analytics_methods";

function getItemstData () {


    const personTickets = analytics_methods.groupByTicketCategory(window?.analytics_buendia?.items) ?? [];
    const personRelatedExtras = analytics_methods.groupByTicketCategoryAndPerson(window?.analytics_buendia?.person_related_extras) ?? []; 
    const generalExtras = analytics_methods.findGeneralExtras(window?.analytics_buendia?.extras, window?.analytics_buendia?.person_related_extras) ?? [];
    const groupedGeneralExtras =  analytics_methods.groupByTicketCategory(generalExtras) ?? [];
    const allExtras = [...personRelatedExtras, ...groupedGeneralExtras];
        
    return [...personTickets, ...allExtras]
}

export default getItemstData;